"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubScpiOpciMoyenneTransactionCoutTrads = void 0;
exports.ESubScpiOpciMoyenneTransactionCoutTrads = {
    between_100k_300k: "Entre 100 000 € et 300 000 €",
    between_15k_50k: "Entre 15 000 € et 50 000 €",
    between_300k_500k: "Entre 300 000 € et 500 000 €",
    between_500k_1000k: "Entre 500 000 € et 1 000 000 €",
    between_50k_100k: "Entre 50 000 € et 100 000 €",
    greater_1000k: "Supérieur à 1 000 000 €",
    less_15k: "Inférieur à 15 000 €",
};
